import en from './en.json';
import zh from './zh.json';
import ja from './ja.json';
import ko from './ko.json';
import es from './es.json';
import pt from './pt.json';

const locales = {
    en,
    zh,
    ja,
    ko,
    es,
    pt,
};

export default locales